import { render, staticRenderFns } from "./SynthesizeAnalyse.vue?vue&type=template&id=494fb402&scoped=true"
import script from "./SynthesizeAnalyse.vue?vue&type=script&lang=js"
export * from "./SynthesizeAnalyse.vue?vue&type=script&lang=js"
import style0 from "./SynthesizeAnalyse.vue?vue&type=style&index=0&id=494fb402&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fb402",
  null
  
)

export default component.exports